<template>
  <div class="reviews-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #title>
        <span class="page-title">{{ $t('ui.reviews.title') }}</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="page-content">
      <article
        v-for="item in visibleReviews"
        :key="item.id"
        class="review-card"
      >
        <div class="review-head">
          <div class="avatar-circle">{{ item.initials }}</div>
          <div class="review-body">
            <div class="review-name">{{ item.name }}</div>
            <div class="stars">
              <img
                v-for="star in 5"
                :key="`${item.id}-${star}`"
                :src="starIcon"
                alt="star"
              >
            </div>
            <p class="review-text">{{ item.text }}</p>

            <img
              v-if="item.image"
              :src="item.image"
              :alt="item.name"
              class="review-image"
            >
          </div>
        </div>
      </article>

      <button
        v-if="reviews.length > initialVisibleCount"
        class="load-more-btn"
        @click="toggleReviews"
      >
        {{ expanded ? $t('ui.reviews.show_less') : $t('ui.reviews.load_more') }}
      </button>
    </div>

  </div>
</template>

<script>
const REVIEW_META = [
  {
    id: 1,
    initials: 'EL',
    name: 'El*na',
    image: 'https://api.sincereloves.online/storage/20260208/uhN1770550341NvtyUl1.jpg'
  },
  {
    id: 2,
    initials: 'CH',
    name: 'Ch***er'
  },
  {
    id: 3,
    initials: 'CH',
    name: 'Ch***es'
  },
  {
    id: 4,
    initials: 'TH',
    name: 'Th**as'
  },
  {
    id: 5,
    initials: 'JO',
    name: 'Jo**ph'
  },
  {
    id: 6,
    initials: 'RI',
    name: 'Ri***rd'
  },
  {
    id: 7,
    initials: 'WI',
    name: 'Wi***am'
  },
  {
    id: 8,
    initials: 'MI',
    name: 'Mi***el'
  },
  {
    id: 9,
    initials: 'RO',
    name: 'Ro**rt'
  },
  {
    id: 10,
    initials: 'JO',
    name: 'John'
  }
];

export default {
  data() {
    return {
      expanded: false,
      initialVisibleCount: 5,
      scrollbarStyleId: 'reviews-scrollbar-style',
      starIcon: 'https://m.sincereloves.online/icon/icon_star.png'
    };
  },
  computed: {
    reviews() {
      // Depend on locale so language switches refresh review texts
      void this.$i18n.locale;
      return REVIEW_META.map((item) => ({
        ...item,
        text: this.$t(`ui.reviews.item_${item.id}_text`)
      }));
    },
    visibleReviews() {
      return this.expanded
        ? this.reviews
        : this.reviews.slice(0, this.initialVisibleCount);
    }
  },
  methods: {
    toggleReviews() {
      this.expanded = !this.expanded;
    },
    hideRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;

      root.style.setProperty('scrollbar-width', 'none');
      body.style.setProperty('scrollbar-width', 'none');
      root.style.setProperty('-ms-overflow-style', 'none');
      body.style.setProperty('-ms-overflow-style', 'none');

      if (!document.getElementById(this.scrollbarStyleId)) {
        const style = document.createElement('style');
        style.id = this.scrollbarStyleId;
        style.textContent = `
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
        `;
        document.head.appendChild(style);
      }
    },
    restoreRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;
      const style = document.getElementById(this.scrollbarStyleId);

      root.style.removeProperty('scrollbar-width');
      body.style.removeProperty('scrollbar-width');
      root.style.removeProperty('-ms-overflow-style');
      body.style.removeProperty('-ms-overflow-style');

      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    }
  },
  mounted() {
    this.hideRootScrollbar();
  },
  beforeDestroy() {
    this.restoreRootScrollbar();
  }
};
</script>

<style lang="less" scoped>
.reviews-page {
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.page-nav {
  min-height: 98px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 88px;
}

::v-deep .page-nav .van-nav-bar__left,
::v-deep .page-nav .van-nav-bar__right {
  padding: 0 18px;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.home-icon {
  color: #e6b98a;
  font-size: 38px;
}

.page-content {
  padding: 20px 14px 120px;
}

.review-card {
  margin-bottom: 22px;
  padding: 24px;
  border: 1px solid #766350;
  border-radius: 20px;
  background: linear-gradient(90deg, #212121, #313131);
}

.review-head {
  display: flex;
  align-items: flex-start;
}

.avatar-circle {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #98d8c8;
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  flex-shrink: 0;
}

.review-body {
  flex: 1;
  margin-left: 22px;
}

.review-name {
  color: #e1e1e1;
  font-size: 22px;
  font-weight: 800;
}

.stars {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 14px;
}

.stars img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.review-text {
  margin: 0;
  color: #a9896e;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.6;
}

.review-image {
  display: block;
  width: 100%;
  margin-top: 18px;
  border-radius: 8px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 20px 0;
  border: 1px solid #766350;
  border-radius: 16px;
  background: linear-gradient(180deg, #393939, #252525);
  color: #f0be88;
  font-size: 20px;
  font-weight: 700;
}

</style>
